import { Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { DATE_FORMAT, TIME_FORMAT } from "@constants";
import { PortInState } from "./interface/IPortIn";
import { format } from "date-fns";

interface IParams {
    portInDateTime?: string;
    portInState: PortInState;
}

export const PortInDetails = (props: IParams) => {
    const { portInDateTime, portInState } = props;
    const { t } = useTranslation("portin");

    const momentPortInDate = portInDateTime ? new Date(portInDateTime) : undefined;
    const portInDate = momentPortInDate ? format(momentPortInDate, DATE_FORMAT) : "";
    const portInTime = momentPortInDate ? format(momentPortInDate, TIME_FORMAT) : "";

    return (
        <Fragment>
            {portInState === PortInState.SCHEDULED && (
                <Typography align="center" variant="normal">
                    {t("portinSchedule", { date: portInDate, time: portInTime })}
                </Typography>
            )}
            {portInState === PortInState.IN_PROGRESS && (
                <Typography align="center" variant="normal">
                    {t("moveInProgress")}
                </Typography>
            )}
        </Fragment>
    );
};
